import { requests } from '@/libs/axios/axios'
import { AxiosResponse } from 'axios'
import { ChatEndpoints } from '../chat-endpoints'
import { ChatHistoryContract } from '@/contracts/chat/ChatHistory.contract'

export const getHistory = async (): Promise<AxiosResponse<ChatHistoryContract[]>> => {
  return requests.get(ChatEndpoints.GET_HISTORY)
}
